export const Config = {
    BASE_URL: 'https://fakestoreapi.com',
};
